<template>
  <div class="si-container">
    <div class="si-content">
      <div class="number" ref="number">{{ item.num }}</div>
      <!-- 图标 -->
      <div class="si-icon-con">
        <img
          :src="require('../../../assets/main/' + item.fileName + '/icon.png')"
          class="si-icon"
          alt=""
          :style="{ width: item.iconWidth }"
        />
      </div>

      <!-- 光柱 -->
      <img
        :src="
          require('../../../assets/main/' + item.fileName + '/circular4.png')
        "
        class="si-img circular4"
        alt=""
        ref="circular4"
      />
      <img
        :src="
          require('../../../assets/main/' + item.fileName + '/circular1.png')
        "
        class="si-img circular1"
        alt=""
        ref="circular1"
      />
      <img
        :src="
          require('../../../assets/main/' + item.fileName + '/circular2.png')
        "
        class="si-img circular2"
        alt=""
        ref="circular2"
      />
      <img
        :src="
          require('../../../assets/main/' + item.fileName + '/circular2.png')
        "
        class="si-img circular2"
        alt=""
        ref="circular6"
      />
      <img
        :src="
          require('../../../assets/main/' + item.fileName + '/circular3.png')
        "
        class="si-img circular3"
        alt=""
        ref="circular3"
      />
      <img
        :src="
          require('../../../assets/main/' + item.fileName + '/circular3.png')
        "
        class="si-img circular3"
        alt=""
        ref="circular5"
      />
    </div>
    <div class="name">{{ item.name }}</div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    beforeDestroy() {
      this.$animejs.remove([
        this.$refs.circular3,
        this.$refs.circular2,
        this.$refs.circular1,
        this.$refs.circular5,
        this.$refs.number,
      ])
    },
    methods: {
      init() {
        //   动画时间线
        let tl = this.$animejs.timeline({
          easing: 'easeInQuad',
        })
        tl.add({
          targets: this.$refs.circular3,
          translateY: [-300, 0],
          scale: [2, 1],
          opacity: [0.5, 1],
          duration: 1000,
        })
          .add(
            {
              targets: this.$refs.circular2,
              translateY: [-300, 0],
              scale: [2, 1],
              opacity: [0.5, 1],
              duration: 1000,
            },
            100
          )
          .add(
            {
              targets: this.$refs.circular1,
              translateY: [-300, 0],
              scale: [2, 1],
              opacity: [0.5, 1],
              duration: 1000,
            },
            200
          )
        setTimeout(() => {
          this.$animejs.remove(this.$refs.circular3)
          this.$animejs({
            targets: this.$refs.circular3,
            scale: [1, 1.5],
            opacity: [1, 0.8, 0.5, 0],
            duration: 2000,
            easing: 'linear',
            loop: true,
          })
        }, 1200)
        setTimeout(() => {
          this.$animejs({
            targets: this.$refs.circular5,
            scale: [1, 1.5],
            opacity: [1, 0.8, 0.5, 0],
            duration: 2000,
            easing: 'linear',
            loop: true,
          })
        }, 2200)
        // 数字滚动动画
        this.$animejs({
          targets: this.$refs.number,
          innerHTML: [0, this.item.num],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .si-container {
    padding: 1.2vh 0;
    .si-content {
      height: 11vh;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 1.1458vw;
      position: relative;
      .number {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        text-align: center;
        padding: 4px;
      }
      .si-icon-con {
        position: absolute;
        z-index: 9;
        width: 1.8975vw;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        flex-direction: row;
      }
      .si-icon {
        width: 1.5625vw;
      }
      .si-img {
        width: 4.635vw;
        position: absolute;
      }
      .circular1 {
        bottom: 20px;
        z-index: 7;
      }
      .circular2 {
        bottom: 8px;
        z-index: 6;
      }
      .circular3 {
        bottom: 0;
        width: 5.833vw;
      }
      .circular4 {
        z-index: 5;
      }
    }
    .name {
      font-size: 12px;
      color: white;
      text-align: center;
      padding-top: 1.0416vw;
    }
  }
</style>
